<template>
  <el-dialog class="model-solution" v-model="modelConnectionOpen" title="">
    <div class="model-solution-img">
      <img src="@/assets/images/modelSolution_img.png" />
    </div>
    <div class="model-solution-content">
      <div class="title">联系我们</div>
      <div class="desc">欢迎联系我们，我们将竭诚为您服务。</div>
      <div class="contact">
        <div class="email">
          <div class="email-icon-box">
            <img
              src="@/assets/images/sidetools_email_icon.png"
              alt=""
              class="email-icon"
            />
          </div>

          <div class="email-content">
            <span class="email-title">邮箱咨询</span>
            <a class="email-text" href="mailto:sales@tipine.cn"
              >sales@tipine.cn</a
            >
          </div>
        </div>
        <div class="qrcode">
          <img src="@/assets/images/code1.png" alt="" class="qrcode-img" />
          <span class="qrcode-text">扫码获取专属客服</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script lang="ts" setup name="ModelSolution">
import { ref, reactive, onMounted } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import EventBus from "@/utils/eventBus";
import { postSolutionApi } from "@/api/module/solution";
const props = withDefaults(
  defineProps<{
    open?: boolean;
  }>(),
  {
    open: false,
  }
);
interface RuleForm {
  name: string;
  number: string;
  enterpriseName: string;
  requirement: string;
}
const modelConnectionOpen = ref<boolean>(false);
const ruleFormRef = ref<FormInstance>();
const form = reactive<RuleForm>({
  name: "",
  number: "",
  enterpriseName: "",
  requirement: "",
});
const rules = reactive<FormRules<RuleForm>>({
  name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
  number: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号格式",
      trigger: "blur",
    },
  ],
  enterpriseName: [
    { required: true, message: "请输入公司名称", trigger: "blur" },
  ],
});
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: boolean, fields: RuleForm) => {
    if (valid) {
      console.log("submit!");
      postSolutionApi(form).then((res: any) => {
        if (res.code === 200) {
          EventBus.$emit("modelConnectionSuccess", true);
          modelConnectionOpen.value = false;
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};
onMounted(() => {
  EventBus.$on("modelConnectionOpen", async function (data: boolean = true) {
    modelConnectionOpen.value = data;
  });
});
</script>
<style lang="scss">
body {
  .model-solution {
    padding: 0;
    border-radius: 20px;
    width: 1050px;
    .el-dialog__header {
      height: 0;
      font-size: 0;
      line-height: 0;
      padding: 0;
      .el-dialog__headerbtn {
        position: absolute;
        background-color: #fff;
        right: -20px;
        top: -20px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        font-size: 24px;
        padding: 0;
        i {
          display: block;
          margin: auto;
        }
      }
    }
    .el-dialog__body {
      display: flex;
      .model-solution-img {
        width: 45%;
        display: block;
        border-radius: 20px 0 0 20px;
        overflow: hidden;
        img {
          width: 100%;
          max-width: 100%;
          display: block;
        }
      }
      .model-solution-content {
        flex: 1;
        padding: 50px;
        .title {
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .desc {
          font-size: 16px;
          text-align: center;
          margin-bottom: 10px;
        }

        .submit-btn {
          height: 60px;
          background-color: #0055d9;
          display: block;
          width: 100%;
          border: 0;
          border-radius: 10px;
          margin-top: 30px;
          font-size: 20px;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  body {
    .model-solution {
      width: 80vw;
      .el-dialog__header {
        .el-dialog__headerbtn {
          width: 60px;
          height: 60px;
          line-height: 60px;
          font-size: 40px;
        }
      }
      .el-dialog__body {
        .model-solution-img {
          display: none;
        }
        .model-solution-content {
          .title {
            font-size: 48px;
          }

          .contact {
            display: flex;
            flex-direction: column;
            padding: 30px;
            min-width: 350px;

            .email {
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              padding: 20px 0;
              &::after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                left: 10%;
                width: 80%;
                height: 1px;
                background-color: #e3e3e3;
              }
              .email-icon-box {
                padding: 20px;
                box-sizing: border-box;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #f0f0f0;
                margin-right: 10px;
                .email-icon {
                  width: 40px;
                  height: 35px;
                  flex-shrink: 0;
                }
              }
              .email-content {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                margin-left: 20px;
                font-family: Source Han Sans CN;

                .email-title {
                  font-weight: 500;
                  font-size: 40px;
                  color: var(--el-text-color-regular);
                  margin-top: 0;
                  line-height: 1.2;
                }
                .email-text {
                  font-weight: 400;
                  font-size: 38px;
                  color: #1767f0;
                  line-height: 1.2;
                  padding: 10px 0;
                  box-sizing: border-box;
                  cursor: pointer;
                  text-decoration: none;
                }
              }
            }
            .qrcode {
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-top: 30px;
              .qrcode-img {
                width: 300px;
                height: 300px;
                margin: 0 auto;
                border: 1px solid #f0f0f0;
                padding: 10px;
              }
              .qrcode-text {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 40px;
                color: var(--el-text-color-regular);
                margin-top: 20px;
                text-align: center;
              }
            }
          }
          .submit-btn {
            height: 110px;
            font-size: 36px;
            margin-top: 60px;
          }
        }
      }
    }
  }
}
</style>
